/**
 * @generated SignedSource<<bbb5ae4a51fa63bf6dbf27755d254fea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SponsorsSection_query$data = {
  readonly sponsorships: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string | null | undefined;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"SponsorsSectionSponsor_guildSponsorship">;
      } | null | undefined;
    }>;
  } | null | undefined;
  readonly " $fragmentType": "SponsorsSection_query";
};
export type SponsorsSection_query$key = {
  readonly " $data"?: SponsorsSection_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"SponsorsSection_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SponsorsSection_query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        }
      ],
      "concreteType": "GuildSponsorshipsConnection",
      "kind": "LinkedField",
      "name": "sponsorships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildSponsorshipsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildSponsorship",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SponsorsSectionSponsor_guildSponsorship"
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "sponsorships(first:2)"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "e797b8faec85026f2ed68330d99c0a66";

export default node;
